import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useCreateBillingMutation, useGetMaintenanceFeeSettingsQuery } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import TextInput from "../../../Common/components/text-input";
import DateInput from "../../../Common/components/date-input";
import SelectInput from "../../../Common/components/select-input";
import { PARTNERS } from "../../../../util/constants/Partners";


const CreateBillingModal = ({ showCreateBillingModal, onHide }) => {
    const [
        createBilling,
        {
            isLoading,
        }
    ] = useCreateBillingMutation()


    const validationSchema = Yup.object({
        periodStartDate: Yup.date().required('Start Date is required'),
        periodEndDate: Yup.date().required('End Date is required'),
    })
    const { data: maintenanceFeeSettings, isLoading: isFetchingSettings } = useGetMaintenanceFeeSettingsQuery();


    return (
        <Modal
            show={showCreateBillingModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Formik
                initialValues={{
                    fee: isFetchingSettings ? 0 : maintenanceFeeSettings?.data?.fee || 0,
                    exemptionConditions: {
                        minimumTrades: isFetchingSettings ? 0 : maintenanceFeeSettings?.data?.exemptionConditions?.minimumTrades || 0,
                        minimumTradeValue: isFetchingSettings ? 0 : maintenanceFeeSettings?.data?.exemptionConditions?.minimumTradeValue || 0,
                    },
                    userGroup: "trove",
                    partner: "dw",
                    periodStartDate: "",
                    periodEndDate: ""
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    createBilling({ ...values })
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Billing Created Successfully")
                            onHide()
                        })
                }}
            >
                {
                    ({ isValid }) => (
                        <Form>
                            <Modal.Header>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                                        <SVG
                                            title=""
                                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg")}
                                        />
                                    </span>
                                    Billing Creation
                                </Modal.Title>
                                <button type="button" className="close" onClick={onHide}>
                                    <span aria-hidden="true" className="d-block">×</span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </Modal.Header>
                            <Modal.Body
                                className="px-10 py-2"
                            >
                                <FormLayout.Row>
                                    <SelectInput
                                        label="Partner"
                                        name="partner"
                                        options={PARTNERS}
                                    />

                                </FormLayout.Row>
                                <FormLayout.Row>
                                    <TextInput
                                        label="Maintenance Fee"
                                        name="fee"
                                        type="number"
                                        min="0.0"
                                    />
                                </FormLayout.Row>
                                <FormLayout.Row>
                                    <TextInput
                                        label="Minimum Trades"
                                        name="exemptionConditions.minimumTrades"
                                        type="number"
                                        min="0.0"
                                    />
                                </FormLayout.Row>
                                <FormLayout.Row>
                                    <TextInput
                                        label="Minimum Trade Value"
                                        name="exemptionConditions.minimumTradeValue"
                                        type="number"
                                        min="0.0"
                                    />
                                </FormLayout.Row>
                                <FormLayout.Row>
                                    <DateInput
                                        label="Start Date*"
                                        name="periodStartDate"
                                        type="number"
                                    />
                                </FormLayout.Row>
                                <FormLayout.Row>
                                    <DateInput
                                        label="End Date*"
                                        name="periodEndDate"
                                        type="number"
                                    />
                                </FormLayout.Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    type="button"
                                    onClick={onHide}
                                    className="btn btn-light btn-elevate px-4"
                                    disabled={isLoading}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-elevate px-4 ml-4"
                                    disabled={isLoading || !isValid}
                                >
                                    Create
                                </button>
                            </Modal.Footer>
                        </Form>
                    )}
            </Formik>
        </Modal>
    );
}

export default CreateBillingModal;